import { unref } from 'vue-demi'
import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { markTenantProjectsDashboardListStale } from '@/store/dashboardListStale'

const prefix = '/post_fitout_submissions'

/**
 * @param {string|number} projectId
 * @returns {Promise<string>}
 */
export async function createPostFitoutSubmission (projectId) {
  try {
    const response = await HTTP.post(`${prefix}/${unref(projectId)}`)
    markTenantProjectsDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'createSubmission')
    throw err
  }
}

export async function updatePostFitoutSubmission (id, request, isSilent) {
  try {
    const response = await HTTP.put(`${prefix}/${id}`, request)
    if (!isSilent) {
      notification.handleResponseAlert(response)
    }
    markTenantProjectsDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

/**
 * @param {OrRef<string|number>} id
 */
export async function getPostFitoutSubmission (id) {
  try {
    const response = await HTTP.get(`${prefix}/${unref(id)}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getProjectPostFitoutSubmissions (query) {
  try {
    const response = await HTTP.get(`${prefix}/list/`, { params: query })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function deletePostFitoutSubmission (id) {
  try {
    const response = await HTTP.delete(`${prefix}/${id}`)
    markTenantProjectsDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
